import React from "react";
import {
  Image,
  ImageStyle,
  Linking,
  Platform,
  Text,
  useWindowDimensions,
  View,
} from "react-native";
import {
  AGENT_PAEG_IMAGE,
  CALL_ICON,
  EMAIL_ICON,
  FAX_ICON,
  INBOX_IMAGE,
  LOCATION_ICON,
} from "../../resources/IMAGES";
import ContactCard, { CardType } from "../ContactCard/ContactCard";
import { displayPhoneFormatter } from "@lib/utilities/Formatters";
import { styles, ids } from "./Styles";

import { AgentDetailType } from "@lib/hooks/contactAgent/agentParser";
import { isTablet } from "react-native-device-info";
import { description, labelText } from "../../resources/strings";

interface ContactAgentViewProps {
  agentDetails: AgentDetailType;
  physicalAddress: string;
  mailingAddress: string;
  agencyName: string;
  findUsMapURL: () => void;
}

const ContactAgentView: React.FC<ContactAgentViewProps> = ({
  agentDetails,
  physicalAddress,
  mailingAddress,
  agencyName,
  findUsMapURL,
}) => {
  const { firstName, lastName, primaryPhoneNumber, emailAddress, faxNumber } =
    agentDetails;

  const contactCards = [
    {
      type: CardType.Location,
      icon: LOCATION_ICON,
      title: labelText.contactAgent.findUs,
      content: physicalAddress,
      onPress: findUsMapURL,
      isFaded: false,
    },
    {
      type: CardType.Mail,
      icon: INBOX_IMAGE,
      title: labelText.contactAgent.mailUs,
      content: mailingAddress,
      isFaded: true,
    },
    {
      type: CardType.Phone,
      icon: CALL_ICON,
      title: labelText.commonLabels.callUs,
      content: displayPhoneFormatter(primaryPhoneNumber),
      onPress: () => Linking.openURL(`tel:${primaryPhoneNumber}`),
      isFaded: false,
    },
    {
      type: CardType.Email,
      icon: EMAIL_ICON,
      title: labelText.commonLabels.emailUs,
      content: emailAddress,
      onPress: () => Linking.openURL(`mailto:${emailAddress}`),
      isFaded: false,
    },
    // {
    //   type: CardType.Fax,
    //   icon: FAX_ICON,
    //   title: labelText.commonLabels.faxUs,
    //   content: displayPhoneFormatter(faxNumber),
    //   isFaded: true,
    // }, fax tile hidden as per business requirement
  ];

  const { height, width } = useWindowDimensions();
  const getOrientationStyles = (): ImageStyle => {
    return {
      transform: [
        {
          scale:
            isTablet() && height > width
              ? Platform.OS == "android"
                ? 0.75
                : 0.78
              : 1,
        },
      ],
      marginLeft:
        isTablet() && height > width
          ? Platform.OS == "android"
            ? "-15%"
            : -height * 0.03
          : 5,
    };
  };
  const HeadingSection = () => (
    <View style={[styles.yourAgenInfo]} dataSet={{ media: ids.yourAgenInfo }}>
      <Text
        style={[styles.headingText]}
        dataSet={{ media: ids.headingText }}
        testID="agents-page-header-label"
      >
        {labelText.contactAgent.yourAgent}
      </Text>
      <Text
        style={[styles.bodyText]}
        dataSet={{ media: ids.bodyText }}
        testID="agents-page-description-label"
      >
        {description.contactAgent.description1}
      </Text>

      <View style={[styles.graphicArea]} dataSet={{ media: ids.graphicArea }}>
        <View
          style={styles.agentImage}
          dataSet={{ media: ids.agentImage }}
          testID="agents-page-image-container"
        >
          <Image
            resizeMode="contain"
            style={[styles.contactAgent, getOrientationStyles()]}
            dataSet={{ media: ids.contactAgent }}
            source={AGENT_PAEG_IMAGE}
            testID="agents-page-image"
          />
        </View>
      </View>
    </View>
  );

  const AgentInfoSection = () => {
    return (
      <View
        style={[styles.contactMyAgentHeading]}
        dataSet={{ media: ids.textLarge }}
      >
        <Text
          style={[styles.textLarge]}
          dataSet={{ media: ids.textLarge }}
          testID="agents-page-contact-agent-header-label"
        >
          {labelText.contactAgent.contactMyAgent}
        </Text>
        {firstName && (
          <Text
            style={[styles.textMedium]}
            dataSet={{ media: ids.textMedium }}
            testID="agents-page-contact-name-label"
          >
            {`${firstName} ${lastName}`}
          </Text>
        )}
        <Text
          style={[styles.textSmall]}
          dataSet={{ media: ids.textSmall }}
          testID="agents-page-contact-agency-label"
        >
          {agencyName}
        </Text>
      </View>
    );
  };

  const getOrientationHeight = () =>
    isTablet() && height > width ? "100%" : height;

  return (
    <View
      style={[styles.contactAgentList]}
      dataSet={{ media: ids.contactAgentList }}
    >
      <View
        style={[styles.contactAgentDetail, { height: getOrientationHeight() }]}
        dataSet={{ media: ids.contactAgentDetail }}
      >
        <HeadingSection />
        <View
          style={[styles.contactInfo]}
          dataSet={{ media: ids.contactInfo }}
          testID="agents-page-agent-section"
        >
          <AgentInfoSection />
          {contactCards.map((card, index) => (
            <ContactCard
              key={index}
              type={card.type}
              icon={card.icon}
              title={card.title}
              content={card.content}
              onPress={card.onPress}
              isFaded={card.isFaded}
              page={"agents"}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

export default React.memo(ContactAgentView);
